import { useState, useEffect } from 'react';
import { getAllBrandProductCount } from '../../../../api/allbrands';

/**
 * Hook to check if a brand has any products on a specific domain
 *
 * @param {Object} selectedBrand - Selected brand option {value: id, label: name}
 * @param {string} domain - Domain to check
 * @returns {boolean} showDomainWarning - Whether to show the warning
 */
export const useBrandDomainWarning = (selectedBrand, domain) => {
  const [showDomainWarning, setShowDomainWarning] = useState(false);

  useEffect(() => {
    const checkDomain = async () => {
      if (!domain || !selectedBrand?.value) {
        setShowDomainWarning(false);
        return;
      }

      try {
        const response = await getAllBrandProductCount(selectedBrand.value, domain);
        setShowDomainWarning(response.count === 0);
      } catch {
        setShowDomainWarning(false);
      }
    };

    checkDomain();
  }, [selectedBrand?.value, domain]);

  return showDomainWarning;
};
